export enum ErrorSeverity {
    All = 'All',
    Error = 'Error',
    Warning = 'Warning',
    Info = 'Info'
}

